import { combineReducers, UnknownAction } from 'redux'

import { RootState } from '@/store'
import { storeActions } from '@/store/actions'
import { adminInitialState, adminReducer } from '@/store/admin'
import { alertInitialState, alertReducer } from '@/store/alert'
import { assistantInitialState, assistantReducer } from '@/store/assistant'
import authReducer, { authInitialState } from '@/store/auth/slice'
import { checkAuth } from '@/store/auth/thunks'
import { beneficiaryInitialState, beneficiaryReducer } from '@/store/beneficiary'
import beneficiaryListReducer, {
  beneficiaryListInitialState,
} from '@/store/beneficiary-list-filters/slice'
import caseWorkerReducer, { caseWorkerListInitialState } from '@/store/case-workers/slice'
import { chatInitialState, chatReducer } from '@/store/chat'
import dashboardTasksReducer, { dashboardTasksInitialState } from '@/store/dashboard-tasks/slice'
import dashboardWidgetsReducer, {
  dashboardWidgetsInitialState,
} from '@/store/dashboard-widgets/slice'
import { demoInitialState, demoReducer } from '@/store/demo'
import { documentInitialState, documentReducer } from '@/store/document'
import { notificationInitialState, notificationReducer } from '@/store/notifications/notification'
import reportTemplatesReducer, { reportTemplatesInitialState } from '@/store/report-templates/slice'
import { signUpInitialState, signUpReducer } from '@/store/signup.ts'
import structuredDataStateReducer, {
  structuredDataStateInitialState,
} from '@/store/structured-data-state/slice'
import { sudoInitialState, sudoReducer } from '@/store/sudo'
import { taskInitialState, taskReducer } from '@/store/task'
import { userInitialState, userReducer } from '@/store/user'

import beneficiaryInsightsReducer, {
  beneficiaryInsightsInitialState,
} from './beneficiary-insights/slice'
import caseWorkerPreferencesReducer, {
  caseWorkerPreferencesInitialState,
} from './case-worker-preferences/slice'

// Combine all reducers
const appReducer = combineReducers({
  admin: adminReducer,
  alert: alertReducer,
  assistant: assistantReducer,
  auth: authReducer,
  beneficiary: beneficiaryReducer,
  beneficiaryList: beneficiaryListReducer,
  beneficiaryInsights: beneficiaryInsightsReducer,
  caseWorkerList: caseWorkerReducer,
  caseWorkerPreferences: caseWorkerPreferencesReducer,
  chat: chatReducer,
  dashboardTasks: dashboardTasksReducer,
  dashboardWidgets: dashboardWidgetsReducer,
  demo: demoReducer,
  document: documentReducer,
  notification: notificationReducer,
  reportTemplates: reportTemplatesReducer,
  signUp: signUpReducer,
  structuredDataState: structuredDataStateReducer,
  sudo: sudoReducer,
  task: taskReducer,
  user: userReducer,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
} satisfies Record<keyof RootState, Function>)

export const initialState: RootState = {
  admin: adminInitialState,
  alert: alertInitialState,
  assistant: assistantInitialState,
  auth: authInitialState,
  beneficiary: beneficiaryInitialState,
  beneficiaryList: beneficiaryListInitialState,
  beneficiaryInsights: beneficiaryInsightsInitialState,
  caseWorkerList: caseWorkerListInitialState,
  caseWorkerPreferences: caseWorkerPreferencesInitialState,
  chat: chatInitialState,
  dashboardTasks: dashboardTasksInitialState,
  dashboardWidgets: dashboardWidgetsInitialState,
  demo: demoInitialState,
  document: documentInitialState,
  notification: notificationInitialState,
  reportTemplates: reportTemplatesInitialState,
  signUp: signUpInitialState,
  structuredDataState: structuredDataStateInitialState,
  sudo: sudoInitialState,
  task: taskInitialState,
  user: userInitialState,
}

// Create the root reducer to reset state on logout
export const rootReducer = (state: RootState | undefined, action: UnknownAction) => {
  switch (action.type) {
    case storeActions.logout.pending.type:
    case checkAuth.rejected.type:
      return appReducer(initialState, action)
  }

  // Otherwise, just process the action as usual
  return appReducer(state, action)
}
